<template>
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--文件上传设置-->
      <div>
        <!-- <el-form-item label="">
          <el-input type="number" :min="0.01" :step="0.01" v-model="form.number" style="width: 200px;"></el-input> 积分兑换一元
        </el-form-item> -->
        <!-- <el-form-item label="规则">
          <el-input v-model="form.description" :autosize="true" type="textarea" :rows="10" class="max-w460"></el-input>
        </el-form-item> -->
        <div class="common-form">POS币使用规则</div>
      <el-form-item v-if="show">
        <Uediter :key="1" :text="form.description" :config="ueditor.config" id="description" @contentChange="contentChangeFunc($event,'description')" />
      </el-form-item>
      </div>
      <!--提交-->
      <div class="common-button-wrapper"><el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button></div>
    </el-form>
  </div>
</template>

<script>
import SettingApi from '@/api/setting.js';
import Uediter from '@/components/UE.vue';


export default {
  components: {
    Uediter
  },
  data() {
    return {
      /*form表单数据*/
      form: {
        // number: 0,
        description: ''
      },
      loading: false,
      ueditor: {
          config: {
              initialFrameWidth: 600,
              initialFrameHeight: 500
          },
      },
      show: false
    };
  },
  created() {
    this.getData();
  },

  methods: {
    contentChangeFunc(e,name) {
      this.form[name] = e
    },
    getData() {
      let self = this;
      SettingApi.getPosCoinSetting({}, true)
        .then(res => {
          self.form.description = res.data.description
          self.show = true
        })
        .catch(error => {});
    },
    //提交表单
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = this.form;
      SettingApi.PosCoin(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '设置成功',
            type: 'success'
          });
        })
        .catch(error => {
          self.loading = false;
        });
    },
  }
};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/pos/index.vue